<form>
  <nb-card>
    <nb-card-body>
      <a class="btn-close" (click)="cancel()">x</a>
      <div class="iframe">
        <iframe webkitallowfullscreen mozallowfullscreen allowfullscreen *ngIf="url" [src]="getUrl()" height="100%"
          width="100%"></iframe>

      </div>
    </nb-card-body>

  </nb-card>
</form>